/*------------------------------------*\
	#AKLAMIO
\*------------------------------------*/

function hideStageOnAklamioPage() {
	const stage = document.querySelector('.js-stage');
	const aklamioPage = document.querySelector('.js-aklamio-container');

	if (aklamioPage) {

		stage.classList.add('is-hidden');

		const headerHeight = document.querySelector('.js-header').offsetHeight;
		aklamioPage.style.marginTop = headerHeight + 'px';
	}

}

document.addEventListener("DOMContentLoaded", () => {
	hideStageOnAklamioPage();
});
